<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      value: this.item_value,
      categoryName: this.$route.params.categoryName,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    d_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
};
</script>
<template>
  <div class="mb-3" :class="{ 'd-none': item.displayOn && !d_check }">
    <Label :item="item" />
    <div class="flex col-12 mt-2">
      <div
        v-for="option in item.options"
        v-bind:key="option"
        class="form-check col-4"
      >
        <input
          class="form-check-input"
          type="radio"
          v-model="value"
          v-bind:value="option"
          :disabled="
            categoryName == 'globalupdate'
              ? false
              : selectedItem && selectedItem.additionalProp1 && selectedItem.additionalProp1.global
              ? true
              : false
          "
          :style="
            option == 'Red'
              ? 'accent-color: red !important'
              : option == 'Amber'
              ? 'accent-color: darkgoldenrod !important'
              : option == 'Green'
              ? 'accent-color: green !important'
              : ''
          "
        />
        <p class="form-check-label ml-2">{{ option }}</p>
      </div>
    </div>

    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
<style scoped>
.form-check-input {
  transform: scale(1.8);
  cursor: pointer;
  accent-color: #005eb8 !important;
}
</style>
